export enum GitHubActionStatus {
    SUCCESS = 'success',
    FAILURE = 'failure',
    CANCELLED = 'cancelled',
    SKIPPED = 'skipped',
}
